module.exports = __webpack_public_path__ + "static/media/tab-wavy-creamy.3f54b44c.png";